import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { getBrandTranslations } from './utils';
import { TDB_LANGUAGE_KEY } from '../utils/constants';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem(TDB_LANGUAGE_KEY) || "es",
    supportedLngs: ["en", "es"],
    fallbackLng: "es",
    ns: ['translation'],
    defaultNS: 'translation',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    interpolation: {
      escapeValue: false
    }
  });

export const loadDynamicTranslations = async ({ code, brand }) => {
  try {
    const brandTranslations = await getBrandTranslations(code, brand);

    if (brandTranslations) {
      i18n.addResourceBundle(
        i18n.language,
        'translation',
        brandTranslations,
        true,
        true
      );
    }
  } catch (error) {
    console.warn(error);
  }
};

export default i18n;